import React, { useEffect, useState, useRef } from "react";
import infoIcon from "../../../../../assets/images/Icons/info_icon.svg";
import {
  makeAjax,
  showMessage,
  url,
  respStatus,
  matchValidateVersi,
} from "../../../../../helpers/global_helper";
import { useSelector, useDispatch } from "react-redux";
import ConfirmBetDeskonPopup from "../../../../Popups/ConfirmBetDeskonPopup";
import BetSuccessPopup from "../../../../Popups/BetSuccessPopup";
import ErrorPopup from "../../../../Popups/ErrorPopup";
import ErrorInnerPopup from "../../../../Popups/ErrorInnerPopup";
import { formatPricewithdecimal, formatPrice } from "../../../../NumberFormat";
import { withTranslation } from "react-i18next";
import CancelledBetDeskonPopup from "../../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance, setCommonConfig } from "../../../../../redux/actions";
import GameClosedPopup from "../../GameClosedPopup";
import MarketClose from "../../MarketClose";

const DasarVersiWap = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [showTooltip, setShowTooltip] = useState(false);
  const [ganjilVal, setGanjilVal] = useState({});
  const [genapVal, setGenapVal] = useState({});
  const [besarVal, setBesarVal] = useState({});
  const [kecilVal, setKecilVal] = useState({});
  const [calculateTotal, setCalculateTotal] = useState({
    gameId: null,
    gameType: "dasar",
    fastbet: true,
  });
  const [RespCalculateTotal, setRespCalculateTotal] = useState({});

  const [reqSubmitData, setReqSubmitData] = useState({
    gameId: null,
    action: "process",
    gameType: "dasar",
    fastbet: true,
    dataangka: [],
    betTogelAuth: "betTogelAuth",
  });

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false);
  const ganjilInputRef = useRef(null);
  const genapInputRef = useRef(null);
  const besarInputRef = useRef(null);
  const kecilInputRef = useRef(null);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const handleInputChange = (e, Type) => {
    const { name, value } = e.target;
    if (Type === "Ganjil") {
      setGanjilVal((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else if (Type === "Genap") {
      setGenapVal((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else if (Type === "Besar") {
      setBesarVal((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else if (Type === "Kecil") {
      setKecilVal((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    setCalculateTotal((prevReqData) => ({
      ...prevReqData,
      gameId: gameId,
      databet_ganjil: ganjilVal["Ganjil"],
      databet_genap: genapVal["Genap"],
      databet_besar: besarVal["Besar"],
      databet_kecil: kecilVal["Kecil"],
      multiple:betDiscount.showMultiple,
    }));
  }, [ganjilVal, genapVal, besarVal, kecilVal]);
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };
  const submitCalculateTotal = () => {
    if (
      !calculateTotal["databet_ganjil"] &&
      !calculateTotal["databet_genap"] &&
      !calculateTotal["databet_besar"] &&
      !calculateTotal["databet_kecil"]
    ) {
      setErrorMessage(props.t("format_input"));
      setShowErrorPopup(true);
      return;
    }

    let matchValidate = matchValidateVersi("dasar", calculateTotal, true);
    if (matchValidate) {
      if (matchValidate == "format_input") {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      } else {
        setErrorMessage(props.t("format_input_on") + " " + matchValidate);
        setShowErrorPopup(true);
        return;
      }
    }

    makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code !== "validation_error") {
          if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
          showMessage(props.t(response.code), "error", "error");
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setRespCalculateTotal(response.data);
      setTotalCountClick(true);
      const newAngakas = [];
      response.data.dataangka.forEach((item) => {
        const newAngaka = [item.nomor, item.taruhan, item.status];
        newAngakas.push(newAngaka);
      });
      setReqSubmitData((prevState) => ({
        ...prevState,
        gameId: gameId,
        dataangka: newAngakas,
      }));
    });
  };

  useEffect(() => {
    allDataReset();
  }, [gameId]);

  const allDataReset = () => {
    setGanjilVal({});
    setGenapVal({});
    setBesarVal({});
    setKecilVal({});
    setRespCalculateTotal({});
    setCalculateTotal({
      gameId: null,
      gameType: "dasar",
      fastbet: true,
    });
    setReqSubmitData({
      gameId: null,
      action: "process",
      gameType: "dasar",
      fastbet: true,
      dataangka: [],
      betTogelAuth: "betTogelAuth",
    });
    setTotalCountClick(false);
    if (ganjilInputRef.current) ganjilInputRef.current.value = "";
    if (genapInputRef.current) genapInputRef.current.value = "";
    if (besarInputRef.current) besarInputRef.current.value = "";
    if (kecilInputRef.current) kecilInputRef.current.value = "";
    setSubmitRespData([]);
  };

  const submitProcess = (event) => {
    if (totalCountClick) {
      setShowConfirmationPopup(true);
    } else {
      if (
        !calculateTotal["databet_ganjil"] &&
        !calculateTotal["databet_genap"] &&
        !calculateTotal["databet_besar"] &&
        !calculateTotal["databet_kecil"]
      ) {
        setErrorMessage(props.t("format_input"));
        setShowErrorPopup(true);
        return;
      }

      let matchValidate = matchValidateVersi("dasar", calculateTotal, true);
      if (matchValidate) {
        if (matchValidate == "format_input") {
          setErrorMessage(props.t(matchValidate));
          setShowErrorPopup(true);
          return;
        } else {
          setErrorMessage(props.t("format_input_on") + " " + matchValidate);
          setShowErrorPopup(true);
          return;
        }
      }

      makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then(
        (response) => {
          if (response.status !== respStatus["SUCCESS"]) {
            if (response.code !== "validation_error") {
              if (response.code === "sub_game_status_close") {
                setShowGameClose(true);
                showMessage(false);
                hideCommonToaster();
                return;
              }
              if (response.code === "market_close_err") {
                setShowMarketClose(true);
                showMessage(false);
                hideCommonToaster();
                return;
              }
              showMessage(props.t(response.code), "error", "error");
              return;
            }
            showMessage("server error No data find", "error", "error");
            return;
          }
          setRespCalculateTotal(response.data);
          const newAngakas = [];
          response.data.dataangka.forEach((item) => {
            const newAngaka = [item.nomor, item.taruhan, item.status];
            newAngakas.push(newAngaka);
          });
          setReqSubmitData((prevState) => ({
            ...prevState,
            gameId: gameId,
            dataangka: newAngakas,
          }));
          setShowConfirmationPopup(true);
        }
      );
    }
    // if (reqSubmitData.dataangka.length > 0) {
    //   setShowConfirmationPopup(true);
    // }
    // else {
    //   setErrorMessage('Incorrect Input Format')
    //   setShowErrorPopup(true)
    // }
  };

  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, reqSubmitData).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        if (response.code !== "validation_error") {
          if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }
          setErrorMessage(props.t(response.code))
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      allDataReset();
      setSubmitRespData((prevData) => [...prevData, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
    });
  };

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true);
    allDataReset();
  };

  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className="rules_container">
            <div>
              <p>{props.t('tengah_dasar_dasar_text')}</p>
              <p>
                Format Tarun: Pilihan1*Pilihan2#10Pilihan3*Pilihan4
                #10+Pilihan4*Pilihan5#1
              </p>
              <p>Conoth Penulisan: b*k#1+gj*gn#2</p>
              <p>Keteramgan : b(besar),k(kecil),gj(ghjil),gn(genap)</p>
            </div>
            <div className="rules_conversion">
              <p>
                Konversi <br /> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div className="versicontainer_new">
            <p>Ganjil</p>
            <textarea
              rows="7"
              placeholder="1 pada Ganjil"
              name="Ganjil"
              ref={ganjilInputRef}
              onChange={(e) => handleInputChange(e, "Ganjil")}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>Genap</p>
            <textarea
              rows="7"
              placeholder="1 pada Genap"
              name="Genap"
              ref={genapInputRef}
              onChange={(e) => handleInputChange(e, "Genap")}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>Besar</p>
            <textarea
              rows="7"
              placeholder="1 pada Besar"
              name="Besar"
              ref={besarInputRef}
              onChange={(e) => handleInputChange(e, "Besar")}
            ></textarea>
          </div>
          <div className="versicontainer_new">
            <p>Kecil</p>
            <textarea
              rows="7"
              placeholder="1 pada Kecil"
              name="Kecil"
              ref={kecilInputRef}
              onChange={(e) => handleInputChange(e, "Kecil")}
            ></textarea>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t("line")}</span> :{" "}
                  {RespCalculateTotal.line
                    ? formatPrice(RespCalculateTotal.line)
                    : "-"}
                </p>
                <p>
                  <span>Total {props.t("purchases")}</span> :{" "}
                  {RespCalculateTotal.tover
                    ? formatPrice(RespCalculateTotal.tover)
                    : "-"}{" "}
                  &nbsp;
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>Total {props.t("discount")}</span>:{" "}
                  {RespCalculateTotal.disc
                    ? formatPrice(RespCalculateTotal.disc)
                    : "-"}
                </p>
                <p>
                  <span>Total {props.t("payment")}</span> :{" "}
                  {RespCalculateTotal.pay}
                </p>
              </div>
              <div className="info_icon">
                <img src={infoIcon} alt="" onClick={toggleTooltip} />
                {showTooltip && (
                  <div
                    className="info_icon_overlay"
                    onClick={() => setShowTooltip(false)}
                  ></div>
                )}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">
                        Contoh Format Taruhan
                      </span>
                      <span className="tooltip_content">
                        1 pada ganjil, genap, besar atau kecil
                      </span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={submitCalculateTotal}>
                  {props.t("count_total")}
                </button>
              </div>
              <div className="button_right">
                <button onClick={allDataReset}>{props.t('reset')}</button>
              </div>
            </div>
            <div className="versiweb_result_right btn_Submit">
              <button onClick={submitProcess}>{props.t('submit')}</button>
            </div>
            {showConfirmationPopup && (
              <ConfirmBetDeskonPopup
                onClose={hanldeConfirmationPopupClose}
                submitProcessOk={submitProcessOk}
              />
            )}
            {successPopup && (
              <div className="popup-overlay ">
                <BetSuccessPopup
                  response={SubmitRespData}
                  onClose={() => setSuccessPopup(false)}
                />
              </div>
            )}
            {showErrorPopup && (
              <ErrorInnerPopup
                modalTitle={""}
                modalHeader={true}
                onCloseModal={() => setShowErrorPopup(false)}
              >
                <ErrorPopup
                  message={errMessage}
                  onClose={() => setShowErrorPopup(false)}
                />
              </ErrorInnerPopup>
            )}

            {showCancelledPopup && (
              <CancelledBetDeskonPopup
                onClose={() => setShowCanclledPopup(false)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default withTranslation()(DasarVersiWap);
